<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Project Member Contributions</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-form class="pa-5">
        <v-row>
          <v-col cols="12">
            <MemberContributionList :memberContributions="contributions" :project.sync="data"></MemberContributionList>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import Alert from "@/components/shared/Alert";
import MemberContributionList from "../child/MemberContributionList";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",
  props: ["uuid", "data"],
  components: { Alert, MemberContributionList },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    succesMsg: "",
    contributions: [],
  }),

  mounted() {
    this.getClubContributionList();
  },

  methods: {
    submit() {
      this.$router.push({
        name: "ProjectEdit",
        params: { step: 5, uuid: this.uuid },
      });
    },

    previous() {
      this.$router.push({
        name: "ProjectEdit",
        params: { step: 3, uuid: this.uuid },
      });
    },

    getClubContributionList() {
      if (this.uuid !== null) {
        ProjectService.getProjectClubContribution(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.contributions = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.contributions = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
  },
};
</script>
